const MORE_FROM_LEXIS_FIELDS = {
    'MotorVehicleSection/MotorVehicleRecords/CurrentVehicles/CurrentVehicle[]': [
        ['AirConditioning', "Air conditioning"],
        ['AntiLockBrakes', "Anti lock brakes"],
        ['DaytimeRunningLights', "Daytime running lights"],
        ['Parties/Party[]/DecalYear', "Decal year (party)"],
        ['PowerBrakes', "Power brakes"],
        ['PowerSteering', "Power steering"],
        ['PowerWindows', "Power windows"],
        ['Radio', "Radio"],
        ['Restraints', "Restraints"],
        ['Roof', "Roof"],
        ['SecuritySystem', "Security system"],
        ['TiltWheel', "Tilt wheel"],
    ],
    'MotorVehicleSection/MotorVehicleRecords/PriorVehicles/PriorVehicle[]': [
        ['AirConditioning', "Air conditioning"],
        ['AntiLockBrakes', "Anti lock brakes"],
        ['DaytimeRunningLights', "Daytime running lights"],
        ['Parties/Party[]/DecalYear', "Decal year (party)"],
        ['PowerBrakes', "Power brakes"],
        ['PowerSteering', "Power steering"],
        ['PowerWindows', "Power windows"],
        ['Radio', "Radio"],
        ['Restraints', "Restraints"],
        ['Roof', "Roof"],
        ['SecuritySystem', "Security system"],
        ['TiltWheel', "Tilt wheel"],
    ],
    'PropertySection/PropertyRecords/Properties/Property[]': [
        ['Accessor/AirConditioningCode', "Air conditioning code (accessor)"],
        ['Accessor/AirConditioningTypeCode', "Air conditioning type code (accessor)"],
        ['Accessor/AirConditioningTypeDesc', "Air conditioning type description (accessor)"],
        ['Accessor/AssesseeOwnershipRightsCode', "Assessee ownership rights code (accessor)"],
        ['Accessor/AssesseeOwnershipRightsDesc', "Assessee ownership rights description (accessor)"],
        ['Accessor/AssesseeRelationshipCode', "Assessee relationship code (accessor)"],
        ['Accessor/ExteriorWallsCode', "Exterior walls code (accessor)"],
        ['Accessor/FipsCode', "Fips code (accessor)"],
        ['Accessor/GarageTypeCode', "Garage type code (accessor)"],
        ['Accessor/HeatingCode', "Heating code (accessor)"],
        ['Accessor/HeatingFuelTypeCode', "Heating fuel type code (accessor)"],
        ['Accessor/HeatingFuelTypeDesc', "Heating fuel type description (accessor)"],
        ['Accessor/HomesteadHomeownerExemption', "Homestead homeowner exemption (accessor)"],
        ['Accessor/MarketImprovementValue', "Market improvement value (accessor)"],
        ['Accessor/MortgageLenderName', "Mortgage lender name (accessor)"],
        ['Accessor/MortgageLoanAmount', "Mortgage loan amount (accessor)"],
        ['Accessor/MortgageLoanTypeCode', "Mortgage loan type code (accessor)"],
        ['Accessor/MortgageLoanTypeDesc', "Mortgage loan type description (accessor)"],
        ['Accessor/NumberOfPartialBaths', "Number of partial baths (accessor)"],
        ['Accessor/NumberOfStoriesDesc', "Number of stories description (accessor)"],
        ['Accessor/OwnerOccupied', "Owner occupied (accessor)"],
        ['Accessor/PoolCode', "Pool code (accessor)"],
        ['Accessor/PoolDesc', "Pool description (accessor)"],
        ['Accessor/PriorRecordingDate', "Prior recording date (accessor)"],
        ['Accessor/RecordTypeCode', "Record type code (accessor)"],
        ['Accessor/RoofTypeCode', "Roof type code (accessor)"],
        ['Accessor/StandardizedLandUseCode', "Standardized land use code (accessor)"],
        ['Accessor/StateCode', "State code (accessor)"],
        ['Deeds/ArmResetDate', "Arm reset date (deeds)"],
        ['Deeds/CityTransferTax', "City transfer tax (deeds)"],
        ['Deeds/CountyTransferTax', "County transfer tax (deeds)"],
        ['Deeds/DocumentTypeCode', "Document type code (deeds)"],
        ['Deeds/FaresIrisApn', "Fares iris parcel number (deeds)"],
        ['Deeds/FaresMortgageDeedType', "Fares mortgage deed type (deeds)"],
        ['Deeds/FaresMortgageDeedTypeDesc', "Fares mortgage deed type description (deeds)"],
        ['Deeds/FaresMortgageTerm', "Fares mortgage term (deeds)"],
        ['Deeds/FaresMortgageTermCode', "Fares mortgage term code (deeds)"],
        ['Deeds/FaresMortgageTermCodeDesc', "Fares mortgage term code description (deeds)"],
        ['Deeds/FaresTransactionType', "Fares transaction type (deeds)"],
        ['Deeds/FaresTransactionTypeDesc', "Fares transaction type description (deeds)"],
        ['Deeds/FirstTdDueDate', "First td due date (deeds)"],
        ['Deeds/FirstTdLoanTypeCode', "First td loan type code (deeds)"],
        ['Deeds/LandLotSize', "Land lot size (deeds)"],
        ['Deeds/PropertyUseCode', "Property use code (deeds)"],
        ['Deeds/PropertyUseDesc', "Property use description (deeds)"],
        ['Deeds/State', "State (deeds)"],
        ['Deeds/TypeFinancing', "Type financing (deeds)"],
        ['Parties/Party[]/Borrowers/Borrower[]/PartyType', "Party type (party borrower)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/AttorneyName', "Attorney name (party foreclosure)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/DefendantCompanyName1', "Defendant company name1 (party foreclosure)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/DefendantName1', "Defendant name1 (party foreclosure)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/PlaintiffName2', "Plaintiff name2 (party foreclosure)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/City', "City (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/State', "State (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/StreetName', "Street name (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/StreetNumber', "Street number (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/StreetPreDirection', "Street pre direction (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/StreetSuffix', "Street suffix (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress1/Zip5', "Zip5 (party foreclosure site address1)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/City', "City (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/State', "State (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/StreetName', "Street name (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/StreetNumber', "Street number (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/StreetPreDirection', "Street pre direction (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/StreetSuffix', "Street suffix (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/UnitNumber', "Unit number (party foreclosure site address2)"],
        ['Parties/Party[]/Foreclosures/Foreclosure[]/SiteAddress2/Zip5', "Zip5 (party foreclosure site address2)"],
        ['Parties/Party[]/Mortgages/Mortgage[]/ContractDate', "Contract date (party mortgage)"],
        ['Parties/Party[]/Mortgages/Mortgage[]/LoanAmount2', "Loan amount2 (party mortgage)"],
        ['Parties/Party[]/Mortgages/Mortgage[]/TransactionType', "Transaction type (party mortgage)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/DefendantCompanyName1', "Defendant company name1 (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/DefendantCompanyName2', "Defendant company name2 (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/DefendantCompanyName3', "Defendant company name3 (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/DefendantCompanyName4', "Defendant company name4 (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/DefendantName1', "Defendant name1 (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/DocumentType', "Document type (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/LenderFirstName', "Lender first name (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/LenderLastName', "Lender last name (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/PlaintiffName1', "Plaintiff name1 (party notice of default)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/City', "City (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/State', "State (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/StreetName', "Street name (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/StreetNumber', "Street number (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/StreetPreDirection', "Street pre direction (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/StreetSuffix', "Street suffix (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress1/Zip5', "Zip5 (party notice of default site address1)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/City', "City (party notice of default site address2)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/State', "State (party notice of default site address2)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/StreetName', "Street name (party notice of default site address2)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/StreetNumber', "Street number (party notice of default site address2)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/StreetPreDirection', "Street pre direction (party notice of default site address2)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/StreetSuffix', "Street suffix (party notice of default site address2)"],
        ['Parties/Party[]/NoticeOfDefaults/NoticeOfDefault[]/SiteAddress2/Zip5', "Zip5 (party notice of default site address2)"],
        ['Parties/Party[]/Owners/Owner[]/PartyType', "Party type (party owner)"],
        ['Parties/Party[]/Sellers/Seller[]/PartyType', "Party type (party seller)"],
        ['SourceObscure', "Source obscure"],
    ],
    'WatercraftSection/WatercraftRecords/CurrentWatercrafts/Watercraft[]': [
        ['CurrentParties/CurrentParty[]/PartyTypeDescription', "Party type description (current party)"],
    ],
    'WatercraftSection/WatercraftRecords/PriorWatercrafts/Watercraft[]': [
        ['NonDMVSource', "Non DMV source"],
        ['PriorParties/PriorParty[]/PartyTypeDescription', "Party type description (prior party)"],
    ],
    'AircraftSection/AircraftRecords/CurrentAircrafts/Aircraft[]': [
        ['CurrentParties/CurrentParty[]/SerialNumber', "Serial number (current party)"],
        ['CurrentParties/CurrentParty[]/registrationDate', "Registration date (current party)"],
    ],
    'AircraftSection/AircraftRecords/PriorAircrafts/Aircraft[]': [
        ['CurrentParties/CurrentParty[]/SerialNumber', "Serial number (current party)"],
        ['CurrentParties/CurrentParty[]/registrationDate', "Registration date (current party)"],
        ['PriorParties/PriorParty[]/SerialNumber', "Serial number (prior party)"],
        ['PriorParties/PriorParty[]/registrationDate', "Registration date (prior party)"],
    ],
    'IRS5500Section/IRS5500s/IRS5500[]': [
        ['Address', "Address"],
        ['AdminSignatureInd', "Admin signature indicator"],
        ['AdminStreetAddress', "Admin street address"],
        ['Administrator/CareOfName', "Care of name (administrator)"],
        ['Administrator/Signature', "Signature (administrator)"],
        ['Administrator/SignatureDate', "Signature date (administrator)"],
        ['BenefitCode', "Benefit code"],
        ['BusinessCode', "Business code"],
        ['FormNumber', "Form number"],
        ['FringeBenefitPlanIndicator', "Fringe benefit plan indicator"],
        ['IsMailingAddr', "Is mailing addr"],
        ['LastReportedSponsorName', "Last reported sponsor name"],
        ['Name', "Name"],
        ['PreParerStrAddress', "Pre parer street address"],
        ['Preparer/Address', "Address (preparer)"],
        ['Preparer/Name', "Name (preparer)"],
        ['Preparer/Phone', "Phone (preparer)"],
        ['RSI', "RSI"],
        ['ScheduleAttachments/SchBAttachedIndicator', "Schedule B attached indicator (schedule attachments)"],
        ['ScheduleAttachments/SchFAttachedIndicator', "Schedule F attached indicator (schedule attachments)"],
        ['ScheduleAttachments/SchTPndgInfoPriorYearDate', "Schedule T pndg info prior year date (schedule attachments)"],
        ['Score', "Score"],
        ['Sponsor/LastReportedName', "Last reported name (sponsor)"],
        ['Sponsor/SignatureDate', "Signature date (sponsor)"],
        ['SponsorDfeCareOfName', "Sponsor DFE care of name"],
        ['SponsorDfeLoc01Address', "Sponsor DFE location 1 address"],
        ['SponsorDfeLoc02Address', "Sponsor DFE location 2 address"],
        ['SponsorDfeMailStrAddress', "Sponsor DFE mail street address"],
        ['SponsorSignatureIndicator', "Sponsor signature indicator"],
        ['TransactionDate', "Transaction date"],
        ['TypePlanFilingIndicator', "Type plan filing indicator"],
        ['WelfareBenefitPlanIndicator', "Welfare benefit plan indicator"],
    ],
    'DunBradStreetSection': [
        ['Dnb/ActiveDunsNumber', "Active DUNS number"],
        ['Dnb/AnnualSalesCode', "Annual sales code"],
        ['Dnb/AnnualSalesVolumeSign', "Annual sales volume sign"],
        ['Dnb/BaseEmploymentTotalSign', "Base employment total sign"],
        ['Dnb/BaseSalesSign', "Base sales sign"],
        ['Dnb/BusinessName', "Business name"],
        ['Dnb/CottageIndicator', "Cottage indicator"],
        ['Dnb/DiasCode', "DIAS code"],
        ['Dnb/EmployeesHereCode', "Employees here code"],
        ['Dnb/EmployeesHereSign', "Employees here sign"],
        ['Dnb/EmployeesTotalSign', "Employees total sign"],
        ['Dnb/HierarchyCode', "Hierarchy code"],
        ['Dnb/IndustryGroup', "Industry group"],
        ['Dnb/MsaCode', "Metro area code"],
        ['Dnb/NetWorthSign', "Net worth sign"],
        ['Dnb/NumberOfAccounts', "Number of accounts"],
        ['Dnb/OrigAddress', "Original address"],
        ['Dnb/OrigMailingAddress', "Original mailing address"],
        ['Dnb/OwnsRents', "Owns rents"],
        ['Dnb/PercentageEmploymentGrowthSign', "Percentage employment growth sign"],
        ['Dnb/RecordType', "Record type"],
        ['Dnb/SalesTerritory', "Sales territory"],
        ['Dnb/StructureType', "Structure type"],
        ['Dnb/TrendEmploymentTotalSign', "Trend employment total sign"],
        ['Dnb/TrendSalesSign', "Trend sales sign"],
        ['Dnb/TypeOfEstablishment', "Type of establishment"],
        ['Dnb/UltimateIndicator', "Ultimate indicator"],
    ],
    'ExperianBusinessReportSection/ExperianBusinessReports/ExperianBusinessReport[]': [
        ['BankingDetails/BankingDetail[]/OrigAddress', "Original address (banking)"],
        ['BankingDetails/BankingDetail[]/TimeZone', "Time zone (banking)"],
        ['BusinessHeader/ExtractDate', "Extract date (business header)"],
        ['BusinessHeader/LastUpdatedDate', "Last updated date (business header)"],
        ['BusinessHeader/OrigAddress', "Original address (business header)"],
        ['BusinessHeader/RecordType', "Record type (business header)"],
        ['BusinessHeader/StateName', "State name (business header)"],
        ['BusinessHeader/TimeZone', "Time zone (business header)"],
        ['Demographics5600/Demographic[]/Location', "Location (demographic)"],
        ['Demographics5600/Demographic[]/OwnerType', "Owner type (demographic)"],
        ['Demographics5600/Demographic[]/Sales', "Sales (demographic)"],
        ['Demographics5610/Demographic[]/OrigOfficerName', "Original officer name (demographic)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/BusinessDescription', "Business description (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/DisputeIndicator', "Dispute indicator (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/ExtractDate', "Extract date (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/FileEstablishDate', "File establish date (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/LastUpdatedDate', "Last updated date (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/OrigAddress', "Original address (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/PhoneNumber', "Phone number (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/RecordType', "Record type (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/SICCode', "SIC code (company)"],
        ['HistoricalCompanyInfo/CompanyInfo[]/StateName', "State name (company)"],
        ['TradePaymentDetails/PaymentDetail[]/PaymentIndicator', "Payment indicator (payment)"],
        ['TradePaymentTotals/TradePaymentTotal[]/AccountBalanceNew', "Account balance new (trade payment total)"],
        ['TradePaymentTotals/TradePaymentTotal[]/AccountBalanceRegular', "Account balance regular (trade payment total)"],
        ['TradePaymentTotals/TradePaymentTotal[]/CombinedTrades/AccountBalanceMask', "Account balance mask (trade payment total combined trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/CombinedTrades/HighCreditMask', "High credit mask (trade payment total combined trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/CombinedTrades/MaskedAccountBalance', "Masked account balance (trade payment total combined trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/NewTrades/AccountBalanceMask', "Account balance mask (trade payment total new trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/NewTrades/HighCreditMask', "High credit mask (trade payment total new trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/NewTrades/RecentHighCredit', "Recent high credit (trade payment total new trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/RegularTrades/AccountBalanceMask', "Account balance mask (trade payment total regular trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/RegularTrades/HighCreditMask', "High credit mask (trade payment total regular trades)"],
        ['TradePaymentTotals/TradePaymentTotal[]/RegularTrades/RecentHighCredit', "Recent high credit (trade payment total regular trades)"],
        ['TradePaymentTrends/PaymentTrend[]/AccountBalanceMask', "Account balance mask (payment trend)"],
        ['TradeQuarterlyAverages/QuarterlyAverage[]/AccountBalanceMask', "Account balance mask (quarterly average)"],
        ['UCCFilings/UCCFiling[]/AdditionalCollateralCodes', "Additional collateral codes (UCC filing)"],
        ['UCCFilings/UCCFiling[]/Type', "Type (UCC filing)"],
    ],
    'ParentSection/Parents/Parent[]': [
        ['ActiveEDA', "Active EDA"],
        ['PhoneInfo/ListingName', "Listing name (phone)"],
        ['PhoneType', "Phone type"],
        ['WirelessIndicator', "Wireless indicator"],
    ],
}

export default MORE_FROM_LEXIS_FIELDS
